import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { LocalStorageService } from './local-storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';

export const DELETE_FCM_TOKEN = gql`
mutation DeleteFCMRegisterToken($deviceId: String) {
    DeleteFCMRegisterToken(deviceId: $deviceId)
  }
`;

@Injectable({
    providedIn: 'root',
})
export class FCMTokenService {

    constructor(
        private apollo: Apollo,
        private localStorageService: LocalStorageService
    ) { }

    deleteFCMToken() {
        return this.apollo.mutate({
            mutation: DELETE_FCM_TOKEN,
            variables: {
                deviceId: this.localStorageService.getItem(LOCAL_STORAGE.DEVICE_ID),
            },
        });
    }
}
